import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Link इम्पोर्ट करें

const CTASection: React.FC = () => {
  return (
    <section className="cta-section py-5 bg-dark text-white text-center">
      <Container>
        <h2 className="mb-4 cta-title">Get Involved</h2>
        <p className="mb-5 cta-text">
          Support our mission to educate, empower, and uplift communities across India.
        </p>
        <div className="cta-buttons">
        <Link to="/donate/">
                     <Button variant="danger" size="lg" className=" cta-btn me-2">
                       Donate Now
                     </Button>
                   </Link>
        <Link to="/volunteer/">
          <Button variant="outline-light" size="lg" className="cta-btn">             
                Volunteer With Us
          </Button>
        </Link>
        </div>
      </Container>
    </section>
  );
};

export default CTASection;
